export class TimeHelper {
    static readonly formatError = 'Please enter a valid time in HH:MM AM/PM format.'; // static for now as the control always uses [format]="12". I assume in the future, we will include a time format option in the Workbench...

    // Accept existing 24-hour data as well as the 12-hour input/picker format.
    static parse(value: unknown): { hours: number; minutes: number } | null {
        if (typeof value !== 'string') {
            return null;
        }

        const match = /^(\d{1,2}):([0-5]\d)(?:\s+(AM|PM))?$/i.exec(value.trim());
        if (!match) {
            return null;
        }

        let hours = Number(match[1]);
        const minutes = Number(match[2]);
        const period = match[3]?.toUpperCase();

        if (period) {
            if (hours < 1 || hours > 12) {
                return null;
            }
            hours = hours % 12 + (period === 'PM' ? 12 : 0);
        } else if (hours > 23) {
            return null;
        }

        return { hours, minutes };
    }
}
